<template>
<v-card>
  <v-card-title v-if='title'>{{title}}</v-card-title>
  <v-card-text class='text-xs-center' >
    <a target="_top" :href="snapUrl" >
      <img :src="snapImg" style='min-width:150px;min-height:150px;' />
    </a>
    <p>{{ $t('info') }}</p>
  </v-card-text>
</v-card>
</template>

<script>
export default {
  name: 'SnapCode',
  props: {
    title: {type: String},
    snapUrl: {type: String},
    snapImg: {type: String}
  },
  i18n: {
    messages: {
      en: {
        info: 'Ask the client to scan this QR code with SnapScan'
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// SnapCode.vue?0f1390fa